import { createSelector } from 'redux-bundler';

/**
 * Select an array of 'options' that can be used in a react-select dropdown
 * { label: 'board name', value: 'board ID' }
 */
export const selectBoardOptions = createSelector(
  'selectBoardIDsByCurrentOrganization',
  'selectBoardsById',
  (boardIDs, boardsById) => {
    const boardOptions = [];

    for (let i = 0, len = boardIDs.length; i < len; i += 1) {
      const boardId = boardIDs[i];
      const { id, active, name } = boardsById[boardId] || {};

      if (id && name && active) {
        boardOptions.push({ label: name, value: boardId });
      }
    }

    return boardOptions.sort((a, b) =>
      a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
    );
  },
);
